'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { isValidElement, PureComponent } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import UIButton from 'UIComponents/button/UIButton';
import UIColumn from 'UIComponents/column/UIColumn';
import UIColumnWrapper from 'UIComponents/column/UIColumnWrapper';
import UIColumnSpreads from 'UIComponents/column/UIColumnSpreads';
import Small from 'UIComponents/elements/Small';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
export default class ResultItem extends PureComponent {
  componentDidUpdate() {
    if (this.props.active) {
      const resultItem = findDOMNode(this);

      if (resultItem) {
        resultItem.scrollIntoView();
      }
    }
  }

  renderIcon(icon) {
    if (!icon) {
      return null;
    }

    const renderedIcon = /*#__PURE__*/isValidElement(icon) ? icon : /*#__PURE__*/_jsx(UIIcon, {
      name: icon
    });
    return /*#__PURE__*/_jsx(UIColumn, {
      className: "result-item-icon",
      children: renderedIcon
    });
  }

  renderTitle(title) {
    return /*#__PURE__*/_jsx("div", {
      className: "result-item-title",
      children: title
    });
  }

  renderHelp(help) {
    if (!help) {
      return null;
    }

    return /*#__PURE__*/_jsx("div", {
      className: "result-item-help",
      children: /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: help
      })
    });
  }

  renderButton({
    buttonText,
    onButtonClick,
    buttonDisabled,
    buttonTooltip
  }) {
    if (!(buttonText && onButtonClick)) {
      return null;
    }

    const button = /*#__PURE__*/_jsx(UIButton, {
      className: "result-item-button",
      disabled: buttonDisabled,
      onClick: onButtonClick,
      size: "small",
      use: "tertiary-light",
      children: buttonText
    });

    if (buttonTooltip) {
      return /*#__PURE__*/_jsx(UITooltip, {
        title: buttonTooltip,
        placement: "right",
        children: button
      });
    }

    return button;
  }

  render() {
    const {
      active,
      buttonText,
      className,
      help,
      icon,
      nested,
      onButtonClick,
      onItemClick,
      title,
      buttonDisabled,
      buttonTooltip
    } = this.props;
    const renderedIcon = this.renderIcon(icon);
    const renderedTitle = this.renderTitle(title);
    const renderedHelp = this.renderHelp(help);
    const renderedButton = this.renderButton({
      buttonText,
      onButtonClick,
      buttonDisabled,
      buttonTooltip
    });
    const itemClasses = classNames("result-item display-inline-flex", className, active && 'result-item--is--active', Boolean(onItemClick) && 'result-item--is--clickable', nested && 'result-item--is--nested', icon !== null && 'result-item--with--icon', renderedButton !== null && 'result-item--with--button');
    return /*#__PURE__*/_jsxs(UIColumnWrapper, {
      align: "start",
      className: itemClasses,
      onClick: onItemClick,
      children: [renderedIcon, /*#__PURE__*/_jsxs(UIColumnSpreads, {
        children: [renderedTitle, renderedHelp]
      }), /*#__PURE__*/_jsx(UIColumn, {
        alignSelf: "center",
        children: renderedButton
      })]
    });
  }

}
ResultItem.displayName = 'ResultItem';
ResultItem.propTypes = {
  active: PropTypes.bool,
  buttonText: PropTypes.node,
  className: PropTypes.string,
  help: PropTypes.node,
  icon: PropTypes.node,
  nested: PropTypes.bool,
  onButtonClick: PropTypes.func,
  onItemClick: PropTypes.func,
  title: PropTypes.node.isRequired,
  buttonDisabled: PropTypes.bool,
  buttonTooltip: PropTypes.node
};
ResultItem.defaultProps = {
  active: false,
  className: '',
  help: null,
  icon: null,
  nested: false,
  buttonDisabled: false,
  buttonTooltip: null
};